import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import VolumePerformanceTestIDs from '/constant/TestIDs/VolumePerformance';
import {useTranslation} from '/provider/TranslationProvider';

import {TAB_NAMES} from '../constants/volumePerformanceReport.constants';
import {styles} from '../styles/VolumePerformanceContent.style';
import {VolPerfTabsProps} from '../types/VolPerfComponent.types';

export const VolPerfTabs = ({activeTab, onTabPress}: VolPerfTabsProps) => {
  const {tt} = useTranslation('report.VolumePerformance');

  const ordersLabel = tt('orders', 'Orders');
  const scheduledLabel = tt('scheduled', 'Scheduled');

  return (
    <View style={styles.tabBar} accessibilityRole="tab">
      <TouchableOpacity
        testID={VolumePerformanceTestIDs.volPerfOrdersTab}
        style={[
          styles.tabItem,
          activeTab === TAB_NAMES.ORDERS && styles.activeTab,
        ]}
        onPress={() => onTabPress(TAB_NAMES.ORDERS)}
        accessibilityRole="tab"
        accessibilityLabel={`${ordersLabel} tab`}
        accessibilityState={{selected: activeTab === TAB_NAMES.ORDERS}}>
        <Text style={styles.tabText} isBold>
          {ordersLabel}
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        testID={VolumePerformanceTestIDs.volPerfScheduledTab}
        style={[
          styles.tabItem,
          activeTab === TAB_NAMES.SCHEDULED && styles.activeTab,
        ]}
        onPress={() => onTabPress(TAB_NAMES.SCHEDULED)}
        accessibilityRole="tab"
        accessibilityLabel={`${scheduledLabel} tab`}
        accessibilityState={{selected: activeTab === TAB_NAMES.SCHEDULED}}>
        <Text style={styles.tabText} isBold>
          {scheduledLabel}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default VolPerfTabs;
